// 羽毛球：【汤尤杯】

// 羽毛球-赛程-常规赛程
const BadmintonScheduleIndex = () =>
  import(
    /* webpackChunkName: "BadmintonScheduleIndex" */ '@platfrom/badminton/schedule/index.vue'
  )

// 羽毛球 赛程详情
const BadmintonScheduleDetail = () =>
  import(
    /* webpackChunkName: "BadmintonScheduleDetail" */ '@platfrom/badminton/scheduleDetail/index.vue'
  )

// 羽毛球-赛程详情 -> 出场名单
const BadmintonScheduleDetailStartList = () =>
  import(
    /* webpackChunkName: "BadmintonScheduleDetailStartList" */ '@platfrom/badminton/scheduleDetail/childPage/startList.vue'
  )

// 羽毛球-赛程详情 -> 本场数据
const BadmintonScheduleDetailLocalData = () =>
  import(
    /* webpackChunkName: "BadmintonScheduleDetailLocalData" */ '@platfrom/badminton/scheduleDetail/childPage/localData.vue'
  )

// 羽毛球-赛程详情 -> 数据分析
const BadmintonScheduleDetailDataAnalysis = () =>
  import(
    /* webpackChunkName: "BadmintonScheduleDetailDataAnalysis" */ '@platfrom/badminton/scheduleDetail/childPage/dataAnalysis.vue'
  )

// 羽毛球-积分榜
const BadmintonLeagueTableIndex = () =>
  import(
    /* webpackChunkName: "badmintonLeagueTableIndex" */ '@platfrom/badminton/leagueTable/index.vue'
  )

// 羽毛球-淘汰赛
const BadmintonKnockoutRoundsIndex = () =>
  import(
    /* webpackChunkName: "badmintonKnockoutRoundsIndex" */ '@platfrom/badminton/knockoutRounds/index.vue'
  )

// 羽毛球-晋级之路
const BadmintonEventsThemeListIndex = () =>
  import(
    /* webpackChunkName: "badmintonEventsThemeListIndex" */ '@platfrom/badminton/eventsThemeList/index.vue'
  )

// // 羽毛球-代表团
// const BadmintonDelegationIndex = () =>
//   import(
//     /* webpackChunkName: "BadmintonDelegationIndex" */ '@platfrom/badminton/delegation/index.vue'
//   )

// // 羽毛球-代表团详情
// const BadmintonDelegationDetailIndex = () =>
//   import(
//     /* webpackChunkName: "BadmintonDelegationDetailIndex" */ '@platfrom/badminton/delegationDetail/index.vue'
//   )

// // 羽毛球-代表团详情 -> 赛程
// const BadmintonDelegationDetailSchedule = () =>
//   import(
//     /* webpackChunkName: "BadmintonDelegationDetailIndex" */ '@platfrom/badminton/delegationDetail/childPage/schedule.vue'
//   )

// // 羽毛球-代表团详情 -> 参赛选手
// const BadmintonDelegationDetailPlayer = () =>
//   import(
//     /* webpackChunkName: "BadmintonDelegationDetailIndex" */ '@platfrom/badminton/delegationDetail/childPage/player.vue'
//   )

// // 羽毛球-代表团详情 -> 获奖明细
// const BadmintonDelegationDetailMedalList = () =>
//   import(
//     /* webpackChunkName: "BadmintonDelegationDetailIndex" */ '@platfrom/badminton/delegationDetail/childPage/medalList.vue'
//   )

// // 羽毛球-运动员
// const BadmintonPlayerIndex = () =>
//   import(
//     /* webpackChunkName: "BadmintonPlayersIndex" */ '@platfrom/badminton/player/index.vue'
//   )

// // 羽毛球-运动员详情
// const BadmintonPlayerDetailIndex = () =>
//   import(
//     /* webpackChunkName: "BadmintonPlayerDetailIndex" */ '@platfrom/badminton/player/playerDetail.vue'
//   )

// // 羽毛球-纪录
// const BadmintonRecordIndex = () =>
//   import(
//     /* webpackChunkName: "BadmintonRecordIndex" */ '@platfrom/badminton/records/index.vue'
//   )

// // 羽毛球-场馆
// const BadmintonVenueIndex = () =>
//   import(
//     /* webpackChunkName: "BadmintonVenueIndex" */ '@platfrom/badminton/venue/index.vue'
//   )

// 羽毛球-播出单
const BadmintonBroadcastListIndex = () =>
  import(
    /* webpackChunkName: "CommonPageBroadcastListIndex" */ '@platfrom/commonPage/broadcastList/index.vue'
  )

// 羽毛球-数据包装
const BadmintonDataPackagListIndex = () =>
  import(
    /* webpackChunkName: "CommonPageDataPackagListIndex" */ '@platfrom/commonPage/dataPackagList/index.vue'
  )

// 羽毛球-节目单
const BadmintonProgramListIndex = () =>
  import(
    /* webpackChunkName: "CommonPageProgramListIndex" */ '@platfrom/commonPage/programList/index.vue'
  )

export default {
  BadmintonScheduleIndex,
  BadmintonScheduleDetail,
  BadmintonScheduleDetailStartList,
  BadmintonScheduleDetailLocalData,
  BadmintonScheduleDetailDataAnalysis,
  BadmintonLeagueTableIndex,
  BadmintonKnockoutRoundsIndex,
  BadmintonEventsThemeListIndex,
  //   BadmintonDelegationIndex,
  //   BadmintonDelegationDetailIndex,
  //   BadmintonDelegationDetailSchedule,
  //   BadmintonDelegationDetailPlayer,
  //   BadmintonDelegationDetailMedalList,
  //   BadmintonPlayerIndex,
  //   BadmintonPlayerDetailIndex,
  //   BadmintonRecordIndex,
  //   BadmintonVenueIndex,
  BadmintonBroadcastListIndex,
  BadmintonDataPackagListIndex,
  BadmintonProgramListIndex,
}
